export function errorText(error) {
  if (error.code === 'SESSION_EXPIRED') return 'Your session expired. Please sign in again.';
  if (!error.response) return 'Unable to connect. Please check your connection and try again.';
  const detail = error.response.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(item => item.msg).join('. ');
  return 'Unable to complete this request. Please try again.';
}

// Never log request configs, response bodies, tokens, passwords or document contents.
export function reportClientError(context, error) {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(context, { status: error?.response?.status, code: error?.code || error?.name });
  }
}